import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { dateTimeutils, dateFormats } from "../../../_utils";

import { MdDelete, MdSearch } from "react-icons/md"; // MdModeEdit,
// import { dateTimeutils, dateFormats } from "../../../_utils";
// import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
// import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";

export class BannerTable extends Component {
  render() {
    const columns = [
      {
        Header: "Title",
        accessor: "title"
      },

      {
        Header: "Description",
        accessor: "description"
      },
      {
        Header: "Expiry Date",
        accessor: "endAt",
        Cell: row => (
          <span>
            {dateTimeutils.formatDateTime(
              row.original.endAt,
              dateFormats.localFormatLong
            )}
          </span>
        )
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      filterData,
      selectRow,
      pages,
      page,
      pageSize,
      deleteCategory,
      showModal,
      setPageNumber,
      setPageSize
    } = this.props;

    const actions = [
      {
        name: "view",
        btnText: "View",
        btnAction: selectRow,
        btnClass: "btn-success",
        btnIcon: MdSearch,
        tooltip: "View"
      },
      {
        name: "cancel",
        btnText: "Delete",
        btnAction: showModal,
        btnClass: "btn-danger",
        btnIcon: MdDelete,
        hiddenParam: "hasPassed",
        tooltip: "Cancel"
      }
    ];

    return (
      <div>
        <Card className="pp4">
          <CardHeader>Banner Ads</CardHeader>
          <CardBody>
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}
            <DataTable
              columns={columns}
              loading={fetching}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              urlParams={match}
              data={data ? data.content : []}
              //  data={data ? data :[]}
              count={data ? data.count : 0}
              defaultPageSize={10}
              deleteRow={deleteCategory}
              selectRow={selectRow}
              showModal={showModal}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="searchKey"
              hideSearchParam={true}
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default BannerTable;
